export default "__VITE_ASSET__oIBoVAFk__"